import styled from "styled-components";


export const DivX = styled.div`
    text-align: right;
`;
